<template lang="pug">
  transition(appear)
    .CoverSection
      .CoverSection_background(:style="backgroundStyleObj" :class="bgClasses")
        slot(name="background")
      .CoverSection_contentContainer(:style="contentStyles")
        slot
</template>

<script>

import COLOR from '@/const.colors.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    backgroundImg: {
      type: String,
      required: false
    },
    backgroundColor: {
      type: String,
      required: false,
      default: COLOR.BLACK
    }
  },
  computed: {
    ...mapGetters(['viewportSize']),
    backgroundStyleObj () {
      const style = {
        backgroundColor: this.backgroundColor
      }

      if (this.backgroundImg) {
        style['background-image'] = `url(${this.backgroundImg})`
      }

      return style
    },
    bgClasses () {
      const classnames = {}

      if (this.backgroundImg) {
        classnames['has-bg-img'] = true
      }

      return classnames
    },
    contentStyles () {
      return {
        height: this.viewportSize.height + 'px'
      }
    }
  }
}
</script>

<style lang="stylus" scope>

.CoverSection
  position relative
  overflow hidden

  &.v-enter
    .CoverSection_background
      opacity 0

  &.v-enter-active
    transition all .8s $ease // TEMPS TOTAL DE L'ANIMATION  !
    .CoverSection_background
      transition opacity .8s $ease

  &_background
    display: block
    position: absolute
    top 0
    left 0
    right 0
    bottom 0
    width 100%
    height 100%
    background-size cover
    background-position center
    background-color $black

    &.has-bg-img
      // tmp - overlay darker image
      &::after
        content ''
        position absolute
        top 0
        right 0
        left 0
        bottom 0
        background-color $black
        opacity .7

  &_contentContainer
    position: relative
    height 100vh
    width 100%
    overflow hidden
    display flex
    flex-direction column
    align-items stretch
    justify-content: center

    @media $mq_m
      min-height 600px

</style>
